import { createFileRoute } from '@tanstack/react-router'
import { Organization } from 'pages/organization/Organization'
import { organizationSearchParams } from 'routes/organization/-searchParams'

const RouteComponent = () => {
  const { mode, orgId } = Route.useSearch()

  return (
    <Organization
      key={`organization-${mode}-${orgId ?? 'new'}`}
      mode={mode}
      orgID={orgId}
    />
  )
}

export const Route = createFileRoute('/organization/')({
  component: RouteComponent,
  staticData: {
    title: 'Organization',
  },
  validateSearch: organizationSearchParams,
  beforeLoad: ({ search }) => {
    if (search.mode === 'edit' && !search.orgId) {
      throw new Error(
        'Edit mode requires organization ID. Use /organization?mode=edit&orgId={orgId}'
      )
    }
  },
})
